import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";

import { CategoryMetas } from "@hermes/api-model-category";
import { ModelObject } from "@hermes/api-model-core";
import { LOCALE, Settings } from "@hermes/app-core";
import { Locale } from "@hermes/locale";

@Injectable()
export class CategoryService {
    constructor(
        @Inject(LOCALE) private locale: Locale,
        private http: HttpClient,
        private settings: Settings,
    ) {}

    public getCategoryFromDacFlat(
        categoryPimCode: string,
    ): Observable<CategoryMetas> {
        return this.http
            .get(
                `${this.settings.apiUrl}/category/${encodeURIComponent(
                    categoryPimCode,
                )}`,
            )
            .pipe(map((data) => ModelObject.fromJsonData(data, CategoryMetas)));
    }
}
